export const containerElementId = 'container';

// All headers here are lowercased which is important since we use them
// as keys in objects, and keys in objects in JavaScript are case sensitive.
// If we don't use lower case we risk setting the same header twice, or unsetting
// a header in one casing but leaving the header with a different casing.
//
// The HTTP standard dictates that header names are case insensitive, so it doesn't
// matter which casing the API uses to read the header values.
export const LINK_IDENTIFIER_HEADER = 'x-link-identifier';
export const ORIGINAL_URL_HEADER_NAME = 'x-original-url';
export const FORWARDED_PROTOCOL_HEADER_NAME = 'x-forwarded-proto';
export const VERSION_HEADER_NAME = 'x-server-version';
export const API_VERSION_HEADER_NAME = 'x-api-version';
export const CLIENT_VERSION_HEADER_NAME = 'x-client-version';
export const COUNTRY_CODE_OVERRIDE_HEADER_NAME = 'x-cf-ipcountry';
export const IS_FULL_PAGE_LOAD_HEADER_NAME = 'x-isfullpageload';
export const SCREEN_SIZE_HEADER_NAME = 'x-screen-size';
export const IS_MOBILE_DEVICE_HEADER_NAME = 'x-is-mobile-device';
export const ORIGINAL_CACHE_CONTROL_HEADER_NAME = 'excite-cdn-cache-control';
export const ORIGINAL_DATE_HEADER_NAME = 'excite-original-date';
export const API_VERSION_QUERY_PARAM_NAME = 'excite-api-version';

// This header indicates to the origin server that it can respond with a 412 during deployment
// swap and that the client will replay the request against the new origin.
export const ALLOW_SWAP_RESPONSE_HEADER_NAME = 'x-allow-swap-response';
